import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const fetchPublishedAnswersList = (filters) => {
  const limit = filters.limit ? `&limit=${filters.limit}` : '';
  const dealerId = filters.dealerId ? `&dealerId=${filters.dealerId}` : '';
  const section = filters.section ? `&section=${filters.section}` : '';
  const formsTypes = filters.formsTypes ? `&formsTypes=${filters.formsTypes}` : '';
  const formType = filters.formType ? `&formType=${filters.formType}` : '';
  const formNumber = filters.formNumber ? `&formNumber=${filters.formNumber}` : '';
  const ofp = filters.ofp ? `&ofp=${filters.ofp}` : '';
  const model = filters.model ? `&model=${filters.model}` : '';
  const cause = filters.cause ? `&cause=${filters.cause}` : '';
  const title = filters.title ? `&title=${filters.title}` : '';
  const startDate = filters.startDate ? `&startDate=${filters.startDate}` : '';
  const endDate = filters.endDate ? `&endDate=${filters.endDate}` : '';
  const typeService = filters.typeService ? `&typeService=${filters.typeService}` : '';

  const allFilters = `${limit}${dealerId}${section}${formsTypes}${formType}${formNumber}${ofp}${model}${cause}` +
    `${title}${startDate}${endDate}${typeService}`;

  return apiActionCreator({
    'endpoint': `/answers/published?${allFilters}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_PUBLISHED_ANSWERS_LIST,
      ActionTypes.FETCHED_PUBLISHED_ANSWERS_LIST,
      [
        ActionTypes.FETCHED_PUBLISHED_ANSWERS_LIST_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'form',
    'method': 'GET',
  });
};

export const changeSearchFtrListPage = (value) => ({
  'type': ActionTypes.CHANGE_SEARCH_FTR_LIST_PAGE,
  'payload': value,
});

export const changeSearchFtrListPageSize = (value) => ({
  'type': ActionTypes.CHANGE_SEARCH_FTR_LIST_PAGE_SIZE,
  'payload': value,
});
